import React, {Component} from 'react';
import TextField from '../../lib/mdb/text-field';
import Selectize from '../../lib/mdb/selectize';
import AmountField from '../../lib/mdb/amount-field';

import {
    cashRequiresCheckNumber, cashRequiresName, isCheck, isCash
} from '../../lib/payment-utils';

/**
 * Displays fields for the cash payment method category.
 */
class PaymentMethodCashFields extends Component {
    render() {
        const {paymentMethod, state, appComponents} = this.props,
            {config} = state,
            {messages} = config,
            pmList = this.filterPaymentMethods(),
            emptyValue = "",
            {type} = paymentMethod;
        const {CheckAccountHolderName} = appComponents;
        return (
            <React.Fragment>
                <div className="col-md-6 col-12">
                    <div className="md-form form-group">
                        <Selectize
                            name="paymentMethod.type"
                            description={messages["payment.cashType.label"]}
                            selectizeOptions={{
                                dropdownParent: "body",
                                highlight: false
                            }}
                            selectList={pmList}
                            autoComplete="off"
                            validations={{
                                required: messages["pmCashType.empty"]
                            }}>
                            <option value="">{emptyValue}</option>
                        </Selectize>
                    </div>
                </div>
                {isCash(type) && (
                  <div className="col-md-6 col-12">
                    <AmountField
                      key="paymentMethod-cashTendered"
                      name="paymentMethod.cashTendered"
                      description={messages["payment.cashTendered.label"] || "Cash Tendered"}
                      validations={{
                        required: value => (value > 0 ? "" : messages["opp.validation.cashAmount.required"] || "Cash amount required"),
                        validateCashTenderedAmount: value => (this.validateCashTenderedAmount(value) 
                                                             ? ""
                                                             : messages["opp.validation.cashAmount.invalid"] || "Cash tendered is less than payment amount")
                      }}
                    />
                  </div>
                )}
                {isCash(type) && (
                  <div className="col-md-6 col-12">
                    <div className="input-group md-form form-row form-sm form-3 pl-0 m-sm-0 col-md-6 cash-change-label">
                      <div className="input-group-prepend cash-change-value">
                        <span>
                          <b>$ {this.getCashChange()}</b>
                        </span>
                      </div>
                      <label className={"active"}>{messages["payment.cashChange.label"] || "Cash Change"} </label>
                    </div>
                  </div>
                )}
                {cashRequiresCheckNumber(type) && (
                    <div className="col-md-6 col-12">
                        <TextField
                            key="paymentMethod-checkNumber"
                            name="paymentMethod.checkNumber"
                            description={messages["payment.checkNumber.label"]}
                            placeholder={messages["payment.checkNumber.tip"]}
                            maxLength="8"
                            className="md-form form-group"
                            labelClass="active"
                            validations={{
                                required: messages["pmCheckNumber.empty"],
                                validCheckNumber: messages["opp.validation.checkNumber.invalid"] || "Check number should contain only numbers or numbers and letters"
                            }}
                            autoComplete="off"/>
                    </div>)
                }
                {cashRequiresName(type) && isCheck(type) && (
                    <div className="col-md-6 col-12">
                        <CheckAccountHolderName
                            key="paymentMethod-accountHolderName"
                            messages={messages}/>
                    </div>
                )}
            </React.Fragment>
        )
    }

   /**
   * This function is used to get the cash change
   */
   getCashChange(){
    let { data } = this.props.state;
    let amount = 0.0;
    let cashChange = amount.toFixed(2);
    let cashTenderedAmount = data.paymentMethod.cashTendered;
    let paymentAmount = data.totalPaymentAmount;
    if (cashTenderedAmount && cashTenderedAmount > 0 && cashTenderedAmount > paymentAmount) {
      cashChange = (cashTenderedAmount - paymentAmount).toFixed(2);
    }
    return cashChange;
  }

  //This method is implemented for the purpose of providing extension to biller specific cash type payment mehtods filteration
  filterPaymentMethods() {
    const { state } = this.props,
      { config } = state,
      { paymentConfig } = config;
    return paymentConfig.paymentMethods.filter(item => item.categoryCode === 'CASH');
  }

  /**
   * This function is used to validate cash tendered amount
   * @returns false if cash tendered amount is less than payment amount
   *                ,otherwise returns true.
   */
  validateCashTenderedAmount(cashTenderedAmount){
    let { data } = this.props.state;
    return !(data.totalPaymentAmount > cashTenderedAmount);
  }
}

export default PaymentMethodCashFields;
